"use strict";
var Observable_1 = require('../../Observable');
var combineLatest_1 = require('../../operator/combineLatest');
Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/~/rxjs/add/operator/combineLatest.js
// module id = ../../../../rxjs/add/operator/combineLatest.js
// module chunks = 4